const WEEKDAYS = ['일', '월', '화', '수', '목', '금', '토'];

export const NEWS_SUBSCRIBED_KEY = 'whatquiz-news-subscribed';

export const kstDay = (offsetDays = 0) => new Date(Date.now() + (9 * 3600 - offsetDays * 86400) * 1000)
  .toISOString()
  .slice(0, 10);

export const SECTION_LABELS = {
  policy: '정책·제도',
  field: '학교 현장',
  global: '해외 에듀테크',
};

export const SECTION_ORDER = ['policy', 'field', 'global'];

const parseDay = (day) => {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(day || '');
  if (!match) return null;
  const [, y, m, d] = match.map(Number);
  return { y, m, d, weekday: WEEKDAYS[new Date(Date.UTC(y, m - 1, d)).getUTCDay()] };
};

export const formatDayLabel = (day) => {
  const parsed = parseDay(day);
  return parsed ? `${parsed.m}월 ${parsed.d}일 ${parsed.weekday}요일` : '';
};

export const formatShortDate = (day) => {
  const parsed = parseDay(day);
  return parsed ? `${parsed.m}.${parsed.d} (${parsed.weekday})` : '';
};

export const formatDDay = (dDay) => (dDay === 0 ? 'D-DAY' : `D-${dDay}`);

export const groupItemsBySection = (items = []) => SECTION_ORDER
  .map((section) => ({ section, items: items.filter((item) => item.section === section) }))
  .filter((group) => group.items.length > 0);
